import Vue from 'vue'
import Vuex from 'vuex'
import {getUser, removeToken, removeUser} from "@/utils/auth";
import {isNull, strToArr} from "@/utils";
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bgColor: "none",
    bgImg: true,
    in_out_date: strToArr(Cookies.get('in_out_date')) || [],
    user: JSON.parse(isNull(getUser())),
    roomParameters: {
      room: 1,
      adult: 1,
      children: 0,
      ChildAgeDetails: []
    } || JSON.parse(isNull(Cookies.get('roomParameters'))),
    destination: JSON.parse(isNull(Cookies.get('destination'))) || {},
    country: {
      name: "中国",
      iso_country_code: "CN"
    },
    dialogLogin: false
  },
  getters: {},
  mutations: {
    setBgColor(state, color) {
      state.bgColor = color;
    },
    setDate(state, date) {
      state.in_out_date = date;
      Cookies.set('in_out_date', date);

    },
    setUserInfo(state, user) {
      state.user = user;
    },
    setDestination(state, destination) {
      state.destination = destination;
      Cookies.set('destination', JSON.stringify(destination));
    },
    setRoomParameters(state, roomParameters) {
      state.roomParameters = roomParameters;
      Cookies.set('roomParameters', roomParameters);
    },
    setBgImg(state, url) {
        state.bgImg = url;
    },
    showDialogLogin(state, isShow) {
        state.dialogLogin = isShow;
    },
    setCountry(state, country) {
      state.country = country;
    },
    logout(state) {
      removeToken();
      removeUser();
      state.user = {};
    }
  },
  actions: {},
  modules: {}
})
